import React from "react"
import styled, { createGlobalStyle } from "styled-components"
import Helmet from "react-helmet"
import "minireset.css"
import { MuiThemeProvider } from "@material-ui/core/styles"

// import app components

import Header from "../../components/header"
import Footer from "../../components/footer"

import { mui } from "../../theme"

import * as theme from "../../theme"

const GlobalStyle = createGlobalStyle`
 a {
   color: ${theme.color.green};
 }
`

const Layout = props => {
  return (
    <MuiThemeProvider theme={mui}>
      <>
        <Helmet>
          <meta name="description" />
        </Helmet>

        <GlobalStyle />

        <Header path={props.location} />
        {props.children}
        <Footer />
      </>
    </MuiThemeProvider>
  )
}

export default Layout

export const Content = styled.div`
  @media (min-width: 600px) {
    padding-top: 60px;
  }
  padding-top: 30px;
  display: flex;
  justify-content: center;
  /* width: 93.5%; */
  margin: 0 auto;
  min-height: calc(100vh - 360px - 64px - 64px);
`
export const PageWrapper = styled.div`
  @media (min-width: 800px) {
    padding-left: 30px;
  }
  width: 100%;
`
